import { ItemBrandsSortOrder } from '@/graphql/types/generated';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { BrandFiltersState } from './types';

const initialState: BrandFiltersState = {
  searchQuery: undefined,
  selectedSortOrder: undefined,
};
const sortMapping: any = {
  name: 'Name',
  id: 'Id',
};

export const brandFiltersSlice = createSlice({
  name: 'brandFilters',
  initialState,
  reducers: {
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },
    resetSearchQuery: (state) => {
      state.searchQuery = '';
    },
    setSortOrderDesc: (state, action: PayloadAction<string>) => {
      const sortDirection = 'Desc';
      const key = sortMapping[action.payload] + sortDirection;

      state.selectedSortOrder =
        ItemBrandsSortOrder[key as keyof typeof ItemBrandsSortOrder];
    },
    setSortOrderAsc: (state, action: PayloadAction<string>) => {
      const sortDirection = 'Asc';
      const key = sortMapping[action.payload] + sortDirection;

      state.selectedSortOrder =
        ItemBrandsSortOrder[key as keyof typeof ItemBrandsSortOrder];
    },
    resetSortOrder: (state) => {
      state.selectedSortOrder = undefined;
    },
    resetState: (state) => {
      state.searchQuery = '';
      state.selectedSortOrder = undefined;
    },
  },
});

export const brandFilterActions = brandFiltersSlice.actions;

export default brandFiltersSlice.reducer;
